import { commonSVG } from '@/Assets/icons';

import './index.scss';
import { useSelector } from 'react-redux';
import { userDataSliceName } from '@/redux/constants';

const EmptyFiles = ({ title = 'Drop your files here', subhead = 'Or use the "New" button' }) => {
  const { isViewerAnalyst } = useSelector((state) => state[userDataSliceName]);
  return (
    <div className='empty-files__container'>
      <div className='flex flex-col justify-center gap-2 py-24 my-8 text-center border border-dashed px-72 rounded-xl bg-ocean-blue-100 bg-opacity-10 border-ocean-blue-200'>
        <img src={commonSVG.EmptyFilesIcon} alt='empty-file-icon' />
        <h3 data-cy='drop-files-here' className='hidden md:block'>
          {isViewerAnalyst ? 'Uh Oh,' : title}
        </h3>
        <p data-cy='use-new-button' className='hidden md:block w-80'>
          {isViewerAnalyst ? 'No files to display' : subhead}
        </p>
      </div>
    </div>
  );
};

export default EmptyFiles;
